export default __webpack_public_path__ + "static/media/Max125_Posterior.62504d1e.webp";